export function uuid() {
  return Math.random().toString(16).slice(2);
}
